import { PublicationsDiscussingController } from './controllers/PublicationsDiscussingController.js';
import { ThemedLotsController } from './controllers/ThemedLotsController.js';
import { AuthorThemedLotsController } from '../forum/controllers/AuthorThemedLotsController.js';
import { PublicationProfileCardController } from './controllers/PublicationProfileCardController.js';
import { PublicationsOtherByAuthorController } from './controllers/PublicationsOtherByAuthorController.js';
import { BasePage } from '../../base/BasePage.js';

export class PublicationViewPage extends BasePage {
    constructor() {

        super();

        const token = window.appData?.token;
        const locale = window.appData?.locale;
        const cp = window.appData?.cp;

        const publicationId = window.appData?.publicationId;
        const sectionId = window.appData?.sectionId;
        const authorId = window.appData?.authorId;
        const viewerId = window.appData?.viewerId;
        const currencyId = window.appData?.currencyId;

        this.initResource({
            controller: new PublicationsDiscussingController(),
            event: 'publication.getMostDiscussed',
            cacheKey: `publication.getMostDiscussed.${cp}`,
            payload: { token, locale }
        });

        this.initResource({
            controller: new PublicationProfileCardController(),
            event: 'publication.profileCard',
            cacheKey: `publication.profileCard.${cp}`,
            payload: { token, locale, authorId }
        });

        this.initResource({
            controller: new PublicationsOtherByAuthorController(),
            event: 'publication.otherByAuthor',
            cacheKey: `publication.otherByAuthor.${cp}`,
            payload: { token, locale, publicationId, authorId, viewerId }
        });

        this.initResource({
            controller: new ThemedLotsController(),
            event: 'publication.themedLots',
            cacheKey: `publication.themedLots.${cp}`,
            payload: { token, locale, publicationId, sectionId, authorId, viewerId, currencyId }
        });
        
        this.initResource({
            controller: new AuthorThemedLotsController(),
            event: 'publication.authorThemedLots',
            cacheKey: `publication.authorThemedLots.${cp}`,
            payload: { token, locale, publicationId, sectionId, authorId, viewerId, currencyId }
        });
    }
}